import { render } from "./BookingNextAvailability.vue?vue&type=template&id=36bd9b03&ts=true"
import script from "./BookingNextAvailability.vue?vue&type=script&lang=ts"
export * from "./BookingNextAvailability.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__